<template>
  <div :class="{ field: true, 'is-danger': $parent.errors.has(name) || ($parent.$parent && $parent.$parent.errors.has(name) ) }">
      <textarea :id="nameProp" ref="input" :value="value" @input="onInput()" :disabled="disabled"
             :class="{ 'input': true, 'filled': isFilled() }"></textarea>
      <label :for="nameProp" v-text="label"></label>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: String,
    disabled: Boolean,
    name: String,
  },
  data () {
    return {
      nameProp: this.name || `input${Math.random()}`
    }
  },
  methods: {
    onInput () {
      this.$emit('input', this.$refs.input.value)
    },
    isFilled () {
      return this.value && this.value.length > 0
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../assets/sass/variables';

$top: 10px;
$padding: calc(0.375rem - 1px) calc(1.925rem - 1px) calc(0.675rem - 1px);

.field {
  position: relative;
  padding-top: $top;
  background: $black;

  textarea, textarea[disabled] {
    color: $white;
    background: transparent;
    border-radius: 0;
    border: none;
    border-bottom: 1px $grey-darker solid;
    box-shadow: none !important;
    padding: $padding;
    height: 8rem;
    resize: none;

    &[disabled] {
      color: $grey-light;
      background: $black;
    }
  }

  & > label {
    position: absolute;
    top: $top; left: 0;
    padding: $padding;
    transition: all 200ms;
    color: $white;
    font-size: 85%;
    text-transform: uppercase;
    cursor: text;
    opacity: 1;
  }

  & > textarea:focus + label,
  & > textarea.filled + label {
    font-size: 71%;
    transform: translate3d(0, -50%, 0);
    opacity: .5;

    cursor: default;
    user-select: none;
  }

  &.is-danger > label {
    color: $red;
    opacity: 1 !important;
  }
}

// Fix autofill color
@-webkit-keyframes autofill {
  to {
    color: $white;
    background: transparent;
  }
}
input:-webkit-autofill {
  -webkit-animation-name: autofill;
  -webkit-animation-fill-mode: both;
}
</style>
